import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export const fetchEmailLogsApi = async (data) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.EMAIL_LOGS.ADD,
    data,
  });
};

